
// Component Styles
const styles = theme => ({
  title:{
    fontSize: '15px'
  }
})
export default styles
